import './button.scss';

import { ReactNode } from 'react';

import { CircularLoader } from '../CircularLoader/CircularLoader';
import { ButtonProps } from './types/ButtonProps';

export const Button = ({
  children,
  className = '',
  disabled = false,
  fullWidth = false,
  loader = false,
  loaderPosition = 'center',
  submit = false,
  underlined = false,
  variant = 'primary',
  ...props
}: ButtonProps): ReactNode => {
  const loaderElement = loader && (
    <span className="button-loader">
      <CircularLoader
        color={
          loaderPosition === 'center'
            ? 'var(--btn-disabled-text-color)'
            : 'currentColor'
        }
      />
    </span>
  );

  const classNames = [
    'button',
    `button-${variant}`,
    fullWidth && 'button-full-width',
    underlined && 'button-underlined',
    loader && `button-loading-${loaderPosition}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      className={classNames}
      disabled={disabled || loader}
      type={submit ? 'submit' : 'button'}
      {...props}
    >
      {loaderPosition !== 'end' && loaderElement}
      {children}
      {loaderPosition === 'end' && loaderElement}
    </button>
  );
};
